import {
  SCREEN_SHARE_RESOURCE_NOT_PERMITTED,
  SCREEN_SHARE_RESOURCE_DENIED,
  SCREEN_SHARE_NO_MEDIA,
  SCREEN_SHARE_NOT_SUPPORTED,
  SCREEN_SHARE_UNKNOWN_ERROR,
  SCREEN_SHARE_SECURITY_ERROR_PERMISSIONS_POLICY,
} from '../../strings';

export const processScreenShareError = (err: unknown): string => {
  let error = '';
  if (err instanceof DOMException) {
    switch (err.name) {
      // Returned if the call to getDisplayMedia() was not made from code running due to a user action, such as an event handler. Another potential cause for this event: the document in whose context getDisplayMedia() was called is not fully active; for example, perhaps it is not the frontmost tab.
      case 'InvalidStateError':
        // This is not due to user action, so don't show the user.
        break;

      // Returned if the permission to access a screen area was denied by the user, or the current browsing instance is not permitted access to screen sharing.
      case 'NotAllowedError':
        if (err.message === 'Permission denied by system') {
          error = SCREEN_SHARE_RESOURCE_NOT_PERMITTED;
        } else {
          error = SCREEN_SHARE_RESOURCE_DENIED;
        }
        break;

      //Returned if no sources of screen video are available for capture.
      case 'NotFoundError':
        error = SCREEN_SHARE_NO_MEDIA;
        break;

      // Returned if the user selected a screen, window, tab, or other source of screen data, but a hardware or operating system level error or lockout occurred, preventing the sharing of the selected source.
      case 'NotReadableError':
        error = SCREEN_SHARE_RESOURCE_DENIED;
        break;

      // Returned if, after creating the stream, applying the specified constraints fails because no compatible stream could be generated.
      case 'OverconstrainedError':
        error = SCREEN_SHARE_NO_MEDIA;
        break;

      // Returned if the specified constraints include constraints which are not permitted when calling getDisplayMedia(). These unsupported constraints are advanced and any constraints which in turn have a member named min or exact.
      case 'TypeError':
        error = SCREEN_SHARE_NOT_SUPPORTED;
        break;

      //Returned if an error or failure does not match any of the other exceptions listed here.
      case 'AbortError':
        error = SCREEN_SHARE_UNKNOWN_ERROR;
        break;

      // XXX: This is not documented by MDN.
      // Example: SecurityError: Failed to execute 'getDisplayMedia' on 'MediaDevices': Access to the feature "display-capture" is disallowed by permission policy.
      case 'SecurityError':
        // If we are missing the permissions policy to screen share, due to being iframed, indicate that specific error.
        if (err.message.includes('"display-capture" is disallowed by permission policy')) {
          error = SCREEN_SHARE_SECURITY_ERROR_PERMISSIONS_POLICY;
        } else {
          error = SCREEN_SHARE_UNKNOWN_ERROR;
        }
        break;

      default:
        error = SCREEN_SHARE_UNKNOWN_ERROR;
        break;
    }
  }
  return error;
};
